// ProgramEvent is equivalent of ApplicationType

export const getProgramEventNameByCode = (events, code) => {
  if(!events){
    return undefined;
  }

  const event = events.find((event => event.code === code));
  return event?.name ?? code;
}

export const getProgramEventByCode = (events, code) => {
  if(!events){
    return undefined;
  }
  
  return events.find((event => event.code === code));
}